"use strict";


/**
 * Paragraph Local Menu "scroll-to" functionality
 */

(function ($, Drupal) {
  Drupal.behaviors.wildcom2018LocalMenu = {
    attach: function (context) {

      once('mwildcom2018-local-menu', '.paragraph--type--local-menu .paragraph--type--menu-item a', context).forEach(function (element) {
        $(element).on('click', function () {
          const hash = this.getAttribute('href').split('#')[1];
          if ((hash) && ($('#' + hash).length)) {
            $('html, body').animate({
              scrollTop: $('#' + hash).offset().top
            }, 2000);
            return false; // remove "return false" to update URL
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
